import React, { useEffect, useState } from "react";
import Logo from "@/components/Logo";

const SEEN_KEY = "ag_welcome_seen_v1";

/**
 * Premium first-login welcome overlay.
 *
 * Shown for ~2 seconds on the very first successful login, then auto-dismisses.
 * Uses localStorage so a user only ever sees it once per browser.
 *
 * Animation timeline (defined in /app/frontend/src/index.css `.ag-welcome-overlay`):
 *   0.0s  → fade-in + 96% → 100% scale
 *   0.4s  → fully visible
 *   2.0s  → fade-out begins
 *   2.4s  → fully gone (component unmounts at 2.4s)
 */
export default function WelcomeOverlay() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let seen = null;
    try { seen = localStorage.getItem(SEEN_KEY); } catch { /* ignore */ }
    if (seen) return;
    setVisible(true);
    try { localStorage.setItem(SEEN_KEY, new Date().toISOString()); } catch { /* ignore */ }
    const t = setTimeout(() => setVisible(false), 2400);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div className="ag-welcome-overlay" data-testid="welcome-overlay" aria-hidden="true">
      <div className="ag-welcome-overlay__inner">
        <Logo
          variant="full"
          tone="dark"
          className="ag-logo-enter h-20 md:h-24 w-auto mx-auto"
        />
        <div className="ag-claim-enter mt-7">
          <div className="font-serif text-2xl md:text-3xl text-white/95 leading-tight">
            Willkommen bei ALLES GEREGELT.
          </div>
          <div className="mt-3 text-sm md:text-base text-amber-200/90 italic">
            Ein gutes Gefühl. Weil alles geregelt ist.
          </div>
        </div>
      </div>
    </div>
  );
}
